import { render } from "./Rule.vue?vue&type=template&id=92409974&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"

import "./Rule.vue?vue&type=style&index=0&id=92409974&lang=scss&scoped=true"
import "./Rule.vue?vue&type=style&index=1&id=92409974&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92409974"]])

export default __exports__